var DistrictOrgList = require("components/appdev/wizards/DistrictOrgList");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");

var DistrictSearch = require("components/org/roster/DistrictSearch");

import { Link } from "react-router-dom";

class CleverAccessTokenList extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { accessTokens: null, selectedDistrict: {}}
	}

	selectDistrict(token, selected ) {
		var selectedDistrict = this.state.selectedDistrict
		selectedDistrict[token.clever_id] = selected
		this.setState({ selectedDistrict })
	}

	renderList() {
		var sortedAccessTokens = _.sortBy(this.state.accessTokens, (token) => {
			return token.created;
		});
		return _.map(sortedAccessTokens, (token) => {
			var route = "/clever_access_tokens/" + token.id + "/details";
			var linkTokenDetail = (
				<Link to={ route }>
					{ token.district.name } | { token.id }
				</Link>
			);
			
			if (token.district.contacts && token.district.contacts.length > 0) {
				var contactEmail = token.district.contacts[0].email
			} else {
				var contactEmail = "No Contacts"
			}

			return (
				<tr key={ token.id }>
					<td>
						{ linkTokenDetail }
					</td>
					<td>
						<ul>
							<li>Created: { token.created }</li>
							<li>Contact: { contactEmail }</li>
						</ul>
					</td>
				</tr>
			);
		});
	}

	handleDistrictOrgCreation(token) {
		var district_org = {name: token.district.name}

		if (this.state.selectedDistrict[token.clever_id]) {
			district_org["canonical_id"] = this.state.selectedDistrict[token.clever_id].value.id
		}

		CurrentUser.api().postDistrictOrgs({ district_org, clever_access_token_id: token.id}, $wr.apiHandler((response) => {
			console.log(response)
			var route = "/district_orgs/" + response.district_org.id + "/details/controls";
			$wr.redirect(route);
		}));
	}

	render() {
		if (this.state.accessTokens == null) {
			return (
				<Spinner placeholder={ true } scale={ 1.7 } />
			);
		} else {
			return (
				<div className="CleverAccessTokenList">
					<table className="table">
						<thead>
							<tr>
								<th>
									Token detail
								</th>
								<th>
								</th>
							</tr>
						</thead>
						<tbody>
							{ this.renderList() }
						</tbody>
					</table>
				</div>
			)
		}
	}

	componentDidMount() {
		CurrentUser.api().getCleverAccessTokens({}, $wr.apiHandler((response) => {
			console.log(response)
			this.setState({ accessTokens: response.clever_access_tokens });
		}));
	}
};

CleverAccessTokenList.propTypes = PageStrictPropTypes({
});

module.exports = CleverAccessTokenList;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverAccessTokenList.js